import Modal from '@jbhi-fi/lanyard-ui/components/Modal';
import React from 'react';
import { styles } from './WalletQRModal.css';
import { Barcode } from '@jbhi-fi/components/src/Barcode';

type WalletQRModalProps = {
  isOpen: boolean;
  onClose: () => void;
  qrCode: string;
};

export const WalletQRModal = ({ isOpen, onClose, qrCode }: WalletQRModalProps) => {
  return (
    <Modal show={isOpen} onClose={onClose} size="lg" customClass={styles.modal}>
      <div className={styles.container}>
        <h2>Scan the QR code with your mobile device to add to your digital wallet</h2>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', height: '330px' }}>
        <Barcode barcodeBase64={qrCode} />
      </div>
    </Modal>
  );
};
